import Dialog from '@mui/material/Dialog'

import { Button } from '../../UI'

import { STUDENT_ROLE } from '../../../constants'

const RoleChangeModal = ({ role = STUDENT_ROLE, open, onContinue, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FEEBDD] !shadow-modal-light',
      }}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <img src={`/assets/image/role_${role}.svg`} alt={role} width={240} height={240} />

        <h2 className="mt-[16px] text-xl font-bold text-primary-100 text-center">
          Switch to <span className="capitalize">{role}</span> Account
        </h2>

        <h3 className="mt-[8px] text-sm font-medium text-primary-100 text-center">
          Switching to {role} account will require you to complete your {role} profile setup.
          <br />
          Press continue to start.
        </h3>

        <Button
          type="button"
          className="!p-0 w-full h-[44px] mt-[24px] font-semibold text-lg shadow-button-second"
          onClick={onContinue}
        >
          Continue
        </Button>

        <button
          type="button"
          className="w-full mt-[8px] h-[44px] font-semibold !text-lg text-[#F79009] border-[#F79009] border-[1px] rounded-[8px] shadow-button hover:bg-primary-button-hover hover:!border-[#e58507] hover:text-white transition-colors duration-200 ease"
          onClick={onClose}
        >
          Back
        </button>
      </div>
    </Dialog>
  )
}

export default RoleChangeModal
